import { jwtDecode } from "jwt-decode";
import React, { useState, useContext, createContext, useEffect } from "react";
import { LS_BROWSER_SESSION_ID_KEY, LS_TOKEN_KEY } from "constants/constants";
import { useSession } from "components/helper/sessionContext";

type TokenContextType = {
    token: string | null;
    setToken: React.Dispatch<React.SetStateAction<string | null>>;
    removeToken: () => void;
};

type TokenContextProviderProps = {
    children: React.ReactNode;
};

const TokenContext = createContext<TokenContextType>({
    token: null,
    setToken: () => {},
    removeToken: () => {},
});

export const useToken = () => useContext(TokenContext);

export const TokenContextProvider = ({
    children,
}: TokenContextProviderProps) => {
    const [token, setToken] = useState<string | null>(() => {
        return localStorage.getItem(LS_TOKEN_KEY);
    });
    const { setSocket } = useSession();

    const removeToken = () => {
        setToken(null);
    };

    useEffect(() => {
        if (token) {
            localStorage.setItem(LS_TOKEN_KEY, token);
            const { sessionID } = jwtDecode(token) as {
                sessionID: string;
            };
            localStorage.setItem(LS_BROWSER_SESSION_ID_KEY, sessionID);
        } else {
            localStorage.removeItem(LS_TOKEN_KEY);
            localStorage.removeItem(LS_BROWSER_SESSION_ID_KEY);
        }
        setSocket(null);
    }, [token, setSocket]);

    return (
        <TokenContext.Provider value={{ token, setToken, removeToken }}>
            {children}
        </TokenContext.Provider>
    );
};
